import React from "react";
import { Box, Paper, Tooltip, IconButton } from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";

const CodeBlock = ({ content }) => {
  const handleCopy = () => {
    navigator.clipboard.writeText(content);
  };

  return (
    <Paper
      elevation={0}
      sx={{
        p: 1.5,
        my: 1,
        bgcolor: "rgba(0,0,0,0.04)",
        borderRadius: 1,
        position: "relative",
        fontFamily: "monospace",
        fontSize: "0.85rem",
        overflow: "auto",
        maxHeight: "150px",
      }}
    >
      <Box sx={{ wordBreak: "break-all", pr: 4 }}>{content}</Box>
      <Tooltip title="Copy to clipboard" placement="top">
        <IconButton
          sx={{
            position: "absolute",
            top: 4,
            right: 4,
            p: 0.5,
            bgcolor: "background.paper",
            "&:hover": { bgcolor: "action.hover" },
          }}
          size="small"
          onClick={handleCopy}
        >
          <ContentCopyIcon fontSize="small" />
        </IconButton>
      </Tooltip>
    </Paper>
  );
};

export default CodeBlock;
